export type NdaRestrictionType = "non_circumvent" | "no_contact";

export type NdaAppliesTo =
  | "tenfifty"
  | "apollo"
  | "tenfifty_and_apollo";

/** Nested user from API (`person_responsible`). */
export interface NdaResponsibleUser {
  id: number;
  name: string;
}

/** Lite deal link on NDA list/detail (`deals` array). */
export interface NdaLinkedDeal {
  id: number;
  deal_name?: string | null;
}

/**
 * Standalone NDA register row.
 * Nested lite on deal GET may omit some fields; drafts from AI extraction have no `id`.
 */
export interface Nda {
  id?: number | null;
  applies_to?: NdaAppliesTo | string | null;
  /**
   * Display label for autocomplete lists (e.g. "TenFifty").
   * Populated client-side when loading reference options.
   */
  applies_to_label?: string;
  restriction_type?: NdaRestrictionType | string | null;
  person_responsible_id?: number | null;
  person_responsible?: NdaResponsibleUser | string | null;
  summary?: string | null;
  expiry_date?: string | null;
  /** All deals linked to this NDA (list/detail responses). */
  deals?: NdaLinkedDeal[] | null;
}

export type NdaDetail = Nda;

export const NDA_APPLIES_TO_OPTIONS: {
  id: NdaAppliesTo;
  name: string;
}[] = [
  { id: "tenfifty", name: "TenFifty" },
  { id: "apollo", name: "Apollo" },
  { id: "tenfifty_and_apollo", name: "TenFifty and Apollo" },
];

export function formatAppliesTo(
  value: string | null | undefined,
): string {
  if (value === "tenfifty") return "TenFifty";
  if (value === "apollo") return "Apollo";
  if (value === "tenfifty_and_apollo") return "TenFifty and Apollo";
  if (value == null || value === "") return "-";
  return value;
}

export function isNdaAppliesTo(
  value: string | null | undefined,
): value is NdaAppliesTo {
  return (
    value === "tenfifty" ||
    value === "apollo" ||
    value === "tenfifty_and_apollo"
  );
}

/** Deal has a restriction when linked to an NDA (or nested lite present with id). */
export function dealHasNda(
  deal: {
    nda_id?: number | null;
    nda?: Nda | null;
  } | null | undefined,
): boolean {
  if (!deal) return false;
  if (typeof deal.nda_id === "number") return true;
  return typeof deal.nda?.id === "number";
}
